import React, { useState, useEffect } from 'react'
import { Select } from '../../../ui-kit'
import { i18n } from '../../../utils/intl'
import { ApiCodeListsRepository } from '../../../api/ApiCodeListsRepository'

type Option = {
  text: string
  value: string
}

export interface PlacesFilterProps {
  onPlaceTypeChange?: (term?: string) => void
}

export const PlacesFilter = (props: PlacesFilterProps) => {
  const [placeType, setPlaceType] = useState('')
  const [options, setOptions] = useState([] as Option[])

  const onPlaceTypeChange = (arg: string) => {
    setPlaceType(arg)
    // eslint-disable-next-line no-unused-expressions
    props.onPlaceTypeChange && props.onPlaceTypeChange(arg === '' ? undefined : arg)
  }

  useEffect(() => {
    ApiCodeListsRepository.fetchMerchantTypes({ params: { per_page: 300 } }).then(data => {
      setOptions([
        {
          text: i18n.t`Všetky prevádzky`,
          value: '',
        },
        ...data.data!.map(i => {
          return {
            text: i.name,
            value: String(i.id),
          }
        }),
      ])
    })
  }, [])

  return (
    <Select
      transparent
      size="small"
      id="filter-places"
      value={placeType}
      onChange={onPlaceTypeChange}
      options={options}
      dropdownStyles={{ minWidth: 170 }}
    />
  )
}
